var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialLedger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5,87.3h19.8c0.6,0,1-0.4,1-1V16c0-0.6-0.4-1-1-1H15.5c-0.6,0-1,0.4-1,1v70.3C14.5,86.9,14.9,87.3,15.5,87.3z M16.5,17  h17.8v68.3H16.5V17z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4,70.8c-2.8,0-5.1,2.3-5.1,5.1s2.3,5.1,5.1,5.1s5.1-2.3,5.1-5.1S28.2,70.8,25.4,70.8z M25.4,79c-1.7,0-3.1-1.4-3.1-3.1  s1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1S27.1,79,25.4,79z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4,47.1h6c0.6,0,1-0.4,1-1V23.5c0-0.6-0.4-1-1-1h-6c-0.6,0-1,0.4-1,1v22.5C21.4,46.6,21.9,47.1,22.4,47.1z M23.4,24.5h4  v20.5h-4V24.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,87.3h19.8c0.6,0,1-0.4,1-1V16c0-0.6-0.4-1-1-1H40.5c-0.6,0-1,0.4-1,1v70.3C39.5,86.9,39.9,87.3,40.5,87.3z M41.5,17  h17.8v68.3H41.5V17z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4,70.8c-2.8,0-5.1,2.3-5.1,5.1s2.3,5.1,5.1,5.1s5.1-2.3,5.1-5.1S53.2,70.8,50.4,70.8z M50.4,79c-1.7,0-3.1-1.4-3.1-3.1  s1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1S52.1,79,50.4,79z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4,47.1h6c0.6,0,1-0.4,1-1V23.5c0-0.6-0.4-1-1-1h-6c-0.6,0-1,0.4-1,1v22.5C46.4,46.6,46.9,47.1,47.4,47.1z M48.4,24.5h4  v20.5h-4V24.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5,87.3h19.8c0.6,0,1-0.4,1-1V16c0-0.6-0.4-1-1-1H65.5c-0.6,0-1,0.4-1,1v70.3C64.5,86.9,64.9,87.3,65.5,87.3z M66.5,17  h17.8v68.3H66.5V17z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4,70.8c-2.8,0-5.1,2.3-5.1,5.1s2.3,5.1,5.1,5.1s5.1-2.3,5.1-5.1S78.2,70.8,75.4,70.8z M75.4,79c-1.7,0-3.1-1.4-3.1-3.1  s1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1S77.1,79,75.4,79z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4,47.1h6c0.6,0,1-0.4,1-1V23.5c0-0.6-0.4-1-1-1h-6c-0.6,0-1,0.4-1,1v22.5C71.4,46.6,71.8,47.1,72.4,47.1z M73.4,24.5h4  v20.5h-4V24.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialLedger);
export default __webpack_public_path__ + "static/media/Material-Ledger.bfc530ac792c8b27f21377cf31fd1cd5.svg";
export { ForwardRef as ReactComponent };